<template>
  <div id="footer" class="container-fluid">
    <div class="foot_content clearfix">
      <div class="foot_left ">
         <div class="foot_companyName">
            <h3>阳光教育服务机构</h3>
            <div>Sunleahoo Education Institution</div>
         </div>
         <div class="foot_companyInfo"> 
          <p>北京总公司：北京市密云区太师屯镇永安街143号</p>
          <p>电话：010 62581722</p>
          <p>邮箱：service@sunleahoo.com</p>
         </div>
    
         <div class="foont_share">
             <span class = "footsa footsa1" ></span>
             <span class="footsa footsa2"></span>
             <el-popover
                placement="top"
                width="200"
                
                trigger="click"
                >
                <h4 class="text-center">官方微信</h4>
                <img class="public_img" src="../../public/img/public.jpg" alt="">
                 <span slot="reference" class="footsa footsa3" ></span>
              </el-popover>
   
             <span class="footsa footsa4" ></span>
         </div>
        
      </div>
      <div class="foot_right">
          <div class="footMenus">
             <dl>
                 <dt>关于我们</dt>
                 <dd>
                    <ul>
                      <!--  -->
                      <li @click="producAuth('/summarySunshine')">公司概况</li>
                      <!-- <li  >联系我们</li> -->
                      <li @click="producAuth('/hotNew')">最新资讯</li>
                    </ul>
                 </dd>
             </dl>
             <dl>
                 <dt>阳光产品</dt>
                 <dd>
                    <ul>
                      <li @click="producAuth('/productCenter/DomesticStudy')">阳光研学</li>
                      <li  @click="producAuth('/productCenter/ComprehensivePractice')">综合实践</li>
                      <li @click="goOutside('https://www.cqedu.online')">课后服务</li>
                      <li @click="producAuth('/productCenter/innovativeTalents')">拔尖人才</li>
                    </ul>
                 </dd>
             </dl>
             <dl>
                 <dt>发现阳光</dt>
                 <dd>
                    <ul>
                      <li @click="producAuth('/productCenter/exploration')">北京模式探索</li>
                      <li  @click="producAuth('/productCenter/studyStandards')">阳光研学标准</li>
                      <li @click="producAuth('/service')">课后解决方案</li>
                    </ul>
                 </dd>
             </dl>
             <dl>
                 <dt>技术支持</dt>
                 <dd>
                    <ul>
                     
                      <li @click="goOutside('https://www.cqedu.online/#/talk')" v-show="!isMobileDevice()">在线客服</li>
                      <li  @click="producAuth('/downloadCenter')">下载中心</li>
                      <li  @click="goOutside('https://www.cqedu.online')"  v-show="!isMobileDevice()">管理入口</li>
                    </ul>
                 </dd>
             </dl>
          </div>
        
      </div>
    </div>

    <div class="foot_bottom ">
      <!-- <div>
       
      </div> -->
      <div class="copyright">
        <p>
          北京阳光众和教育科技有限公司 版权所有&nbsp;| © 2021 sunleahoo.All Rights
          Reserved.
        </p>
        <p>
          法律声明 |
          <a target="_blank" href="https://beian.miit.gov.cn/"
            >京ICP备2026045644号</a
          >&nbsp;|
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802036593"
          >
            <img src="../../public/img/beian.png" />京公网安备 11010802036593号
          </a>
        </p>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return { 
    };
    
  },
  methods: {
  
    isMobileDevice() {
          return window.matchMedia("(max-width: 768px)").matches; // 768px通常被认为是平板设备的界限
    },

    producAuth(path) {
      this.$router.push({ path: path })
      
    },
    goOutside(url) {
     window.open(url, '_blank');
    }
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #272727 ;
  overflow: hidden;
  position: relative;
    z-index: 9;
  /* margin-top: 100px; */

}
.foot_content{
  width: 78%; 
  height: auto;
  margin: 0 auto;
  padding: 50px 0 20px 0;
  display: flex;
  justify-content: space-between;
}
.foot_left {
  flex: 1;
}

.foot_companyName h3{
   margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.foot_content p{
  color: #999999;
}
.foot_companyInfo{
  margin: 20px 0;
}
.foot_companyInfo p{
  margin-bottom: 5px;
}
.foot_bottom{
  width: 100%;
   padding: 20px 0;
  text-align: center;
  font-size: 14px;
  color: #666666;
  border-top: 1px solid #333333;
}
 .foot_bottom .copyright p{color: #bbbbbb;}
 .foot_bottom .copyright p img{display: inline-block;}
 .foot_bottom .copyright a{color: #bbbbbb;}
.foont_share span{
   display: inline-block;
   width: 40px;
   height: 40px;
   border-radius: 50%;
   background-repeat: no-repeat;
   background-position: center center;
   transform: scale(0.9);
   margin-right: 5px;
   background-size: cover;
   cursor: pointer;
}
.footsa1{
  background-image: url(../../public/img/foot_si1.png);
}
.footsa2{
  background-image: url(../../public/img/foot_si2.png)
}
.footsa3{
  background-image: url(../../public/img/foot_si3.png);
}
.footsa4{
  background-image: url(../../public/img/foot_si4.png);
}
.footMenus dl{
  float: left;
  margin-right: 90px;
}
.footMenus dl:nth-child(4){
  margin-right: 0;
}
.footMenus dt{
  font-size: 18px;
  color: #d3cdcd;
  line-height: 20px;
  height: 20px;
  margin-bottom: 28px;
  position: relative;
  font-weight: 600;
}

.footMenus dd {
    font-size: 16px;
    line-height: 35px;
    color: #bbbbbb;
    cursor: pointer;
}
.public_img{
  width: 150px;
  height: auto;
  margin: 0 auto;
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  .foot_content {
    display: table;

  }
  .footMenus{
    margin-top: 20px;
  }
  .footMenus dl{
    float: left;
    margin-right: 50px;
  }
}
/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .foot_content {
    display: table;
    width: 89%;
    padding: 0;
  }
  .foot_companyInfo{
    margin: 10px 0;
  }
  .footMenus{
    margin-top: 20px;
  }
  .foot_companyName h3{
    font-size: 18px;
    margin-top: 20px;
  }
  .footMenus dl {
        width: 100%;
        margin-right: 0;
        overflow: hidden;
        margin-bottom: 0;
    }
    .footMenus dd{line-height: 20px;}
    .footMenus dl dt {
        width: 100%;
        margin-bottom: 16px;
    }
    .footMenus dl dd ul {
        float: none;
        display: inline-block;
    }
    .footMenus dl dd ul li {
        float: none;
        display: inline-block;
        margin-right: 15px;
    }
    .foot_bottom {
      /* height: 50px;
      line-height: 50px;
      font-size: 12px; */

    }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue